import { fillArrayHoles } from '@/Constants/holes';
import { tAccessoriesBlenderName } from '@/Constants/caseComponentsLib/caseComponentsLib';
import { tBlenderCaseModel } from '@/Interfaces/caseComponentsLib';

export type tAccessoryHoles = { [key in tBlenderCaseModel ]: { x : number[], y: number[] } };

export const whKeyHolder: tAccessoryHoles = {
    'tc_1947': { x: [], y: [] },
    'tc_1995': { x: [], y: [] },
    'tc_1095': { x: [], y: [] },
    'tc_1995_2': { x: [], y: [] },
    'amh_tc': { x: [], y: [] },
    'amh_tc_el': { x: [], y: [] },
    'hard_1000': { x: [], y: [] },
    'hard_2000': { x: [], y: [] },
};

export const hexagonHolderHH: tAccessoryHoles = {
    'tc_1947': { x: [], y: [] },
    'tc_1995': { x: [], y: [] },
    'tc_1095': { x: [], y: [] },
    'tc_1995_2': { x: [], y: [] },
    'amh_tc': { x: [], y: [] },
    'amh_tc_el': { x: [], y: [] },
    'hard_1000': { x: [], y: [] },
    'hard_2000': { x: [], y: [] },
};
export const paperTowelHolderPTH: tAccessoryHoles = {
    'tc_1947': { x: [], y: [] },
    'tc_1995': { x: [], y: [] },
    'tc_1095': { x: [], y: [] },
    'tc_1995_2': { x: [], y: [] },
    'amh_tc': { x: [], y: [] },
    'amh_tc_el': { x: [], y: [] },
    'hard_1000': { x: [], y: [] },
    'hard_2000': { x: [], y: [] },
};
export const plasticBoxHolder200SPBH: tAccessoryHoles = {
    'tc_1947': { x: [], y: [] },
    'tc_1995': { x: [], y: [] },
    'tc_1095': { x: [], y: [] },
    'tc_1995_2': { x: [], y: [] },
    'amh_tc': { x: [], y: [] },
    'amh_tc_el': { x: [], y: [] },
    'hard_1000': { x: [], y: [] },
    'hard_2000': { x: [], y: [] },
};

export const shelfLargeLSH = {
    'amh_tc': { x: [], y: [] },
    'amh_tc_el': { x: [], y: [] },
    'hard_1000': { x: [], y: [] },
    'hard_2000': { x: [], y: [] },
};

export const trayHolderA4: tAccessoryHoles = {
    'tc_1947': { x: [], y: [] },
    'tc_1995': { x: [], y: [] },
    'tc_1095': { x: [], y: [] },
    'tc_1995_2': { x: [], y: [] },
    'amh_tc': { x: [], y: [] },
    'amh_tc_el': { x: [], y: [] },
    'hard_1000': { x: [], y: [] },
    'hard_2000': { x: [], y: [] },
};
export const ushmHolder: tAccessoryHoles = {
    'tc_1947': { x: [], y: [] },
    'tc_1995': { x: [], y: [] },
    'tc_1095': { x: [], y: [] },
    'tc_1995_2': { x: [], y: [] },
    'amh_tc': { x: [], y: [] },
    'amh_tc_el': { x: [], y: [] },
    'hard_1000': { x: [], y: [] },
    'hard_2000': { x: [], y: [] },
};

export const hookHk280: tAccessoryHoles = {
    'tc_1947': { x: [], y: [] },
    'tc_1995': { x: [], y: [] },
    'tc_1095': { x: [], y: [] },
    'tc_1995_2': { x: [], y: [] },
    'amh_tc': { x: [], y: [] },
    'amh_tc_el': { x: [], y: [] },
    'hard_1000': { x: [], y: [] },
    'hard_2000': { x: [], y: [] },
};

export const plasticBox400x230x150: tAccessoryHoles = {
    'tc_1947': { x: [], y: [] },
    'tc_1995': { x: [], y: [] },
    'tc_1095': { x: [], y: [] },
    'tc_1995_2': { x: [], y: [] },
    'amh_tc': { x: [], y: [] },
    'amh_tc_el': { x: [], y: [] },
    'hard_1000': { x: [], y: [] },
    'hard_2000': { x: [], y: [] },
};


export const mapAccessoryToHoles: {
    [key in tAccessoriesBlenderName]: tAccessoryHoles
} = {
    'wh_key_holder': whKeyHolder,
    'hexagon_holder_hh': hexagonHolderHH,
    'paper_towel_holder_pth': paperTowelHolderPTH,
    'plastic_box_holder_200_SPBH': plasticBoxHolder200SPBH,
    'shelf_large_lsh': shelfLargeLSH,
    'tray_holder_a4': trayHolderA4,
    'ushm_holder': ushmHolder,
    'hook_hk_2_80': hookHk280,
    'plastic_box_400x230x150': plasticBox400x230x150,
};


//Расстояние между перфорациями экрана 0.038
//для широких экранов смещение 0.019 тк пивод расположен по середине между отверстиями

//держатель ключей
fillArrayHoles([
    { distance: 0.038, repeat: 7 }, { distance: 0.086, repeat: 1 },
    { distance: 0.038, repeat: 2 }, { distance: 0.08, repeat: 1 },
    { distance: 0.038, repeat: 7 }, { distance: 0.086, repeat: 1 },
    { distance: 0.038, repeat: 2 }, { distance: 0.08, repeat: 1 },
    { distance: 0.038, repeat: 7 },
], 30, whKeyHolder.tc_1995.y, 0.387);
fillArrayHoles([
    { distance: 0.038, repeat: 9 }, { distance: 0.1, repeat: 1 },
    { distance: 0.038, repeat: 9 },
], 20, whKeyHolder.tc_1995.x, -0.392);

//tc_1095.y - экраны накладываются друг на друга в центре
fillArrayHoles([
    { distance: 0.038, repeat: 6 }, { distance: 0.019, repeat: 3 },
    { distance: 0.038, repeat: 10 },
], 20, whKeyHolder.tc_1095.y, 0.092);

fillArrayHoles([
    { distance: 0.038, repeat: 7 }, { distance: 0.228, repeat: 1 },
    { distance: 0.038, repeat: 7 },
], 16, whKeyHolder.tc_1995_2.y, 0.387, 0.501, 0.837);

fillArrayHoles([ { distance: 0.038, repeat: 23 } ], 23, whKeyHolder.tc_1947.y, 0.894);

fillArrayHoles([ { distance: 0.038, repeat: 28 } ], 28, whKeyHolder.amh_tc.y, 0.616);
fillArrayHoles([ { distance: 0.038, repeat: 20 } ], 20, whKeyHolder.amh_tc.x, -0.361);

fillArrayHoles([ { distance: 0.038, repeat: 42 } ], 42, whKeyHolder.hard_2000.y, 0.18);
fillArrayHoles([ { distance: 0.038, repeat: 25 } ], 25, whKeyHolder.hard_2000.x, -0.456);


whKeyHolder.tc_1095.x = [ ...whKeyHolder.tc_1995.x ];
fillArrayHoles([ { distance: 0.038, repeat: 10 } ], 10, whKeyHolder.tc_1947.x, 0.062);
whKeyHolder.tc_1995_2.x = [ ...whKeyHolder.tc_1995.x ];
whKeyHolder.amh_tc_el.y = [ ...whKeyHolder.amh_tc.y ];
whKeyHolder.amh_tc_el.x = [ ...whKeyHolder.amh_tc.x ];
whKeyHolder.hard_1000.y = [ ...whKeyHolder.hard_2000.y ].splice(0, 15);
whKeyHolder.hard_1000.x = [ ...whKeyHolder.hard_2000.x ];


//держатель шестигрангника
fillArrayHoles([
    { distance: 0.038, repeat: 11 }, { distance: 0.086, repeat: 1 },
    { distance: 0.038, repeat: 11 }, { distance: 0.086, repeat: 1 },
    { distance: 0.038, repeat: 11 },
], 36, hexagonHolderHH.tc_1995.y, 0.387);
fillArrayHoles([
    { distance: 0.038, repeat: 6 }, { distance: 0.214, repeat: 1 },
    { distance: 0.038, repeat: 6 },
], 14, hexagonHolderHH.tc_1995.x, -0.392);

fillArrayHoles([
    { distance: 0.038, repeat: 10 }, { distance: 0.019, repeat: 3 },
    { distance: 0.038, repeat: 10 },
], 24, hexagonHolderHH.tc_1095.y, 0.092);

fillArrayHoles([
    { distance: 0.038, repeat: 11 }, { distance: 0.086, repeat: 1 },
    { distance: 0.038, repeat: 11 },
], 24, hexagonHolderHH.tc_1995_2.y, 0.387, 0.501, 0.837);

fillArrayHoles([ { distance: 0.038, repeat: 26 } ], 26, hexagonHolderHH.tc_1947.y, 0.894);

fillArrayHoles([ { distance: 0.038, repeat: 33 } ], 33, hexagonHolderHH.amh_tc.y, 0.616);
fillArrayHoles([ { distance: 0.038, repeat: 19 } ], 19, hexagonHolderHH.amh_tc.x, -0.399);

fillArrayHoles([ { distance: 0.038, repeat: 47 } ], 47, hexagonHolderHH.hard_2000.y, 0.143);
fillArrayHoles([ { distance: 0.038, repeat: 24 } ], 24, hexagonHolderHH.hard_2000.x, -0.494);


hexagonHolderHH.tc_1095.x = [ ...hexagonHolderHH.tc_1995.x ];
fillArrayHoles([ { distance: 0.038, repeat: 7 } ], 7, hexagonHolderHH.tc_1947.x, 0.065);
hexagonHolderHH.tc_1995_2.x = [ ...hexagonHolderHH.tc_1995.x ];
hexagonHolderHH.amh_tc_el.y = [ ...hexagonHolderHH.amh_tc.y ];
hexagonHolderHH.amh_tc_el.x = [ ...hexagonHolderHH.amh_tc.x ];
hexagonHolderHH.hard_1000.y = [ ...hexagonHolderHH.hard_2000.y ].splice(0, 20);
hexagonHolderHH.hard_1000.x = [ ...hexagonHolderHH.hard_2000.x ];

//держатель полотенец
paperTowelHolderPTH.tc_1995.y = [ ...hexagonHolderHH.tc_1995.y ];
fillArrayHoles([
    { distance: 0.038, repeat: 2 }, { distance: 0.366, repeat: 1 },
    { distance: 0.038, repeat: 2 },
], 6, paperTowelHolderPTH.tc_1995.x, -0.392);


fillArrayHoles([
    { distance: 0.038, repeat: 9 }, { distance: 0.019, repeat: 3 },
    { distance: 0.038, repeat: 10 },
], 23, paperTowelHolderPTH.tc_1095.y, 0.13);
paperTowelHolderPTH.tc_1095.x = [ ...paperTowelHolderPTH.tc_1995.x ];

paperTowelHolderPTH.tc_1995_2.x = [ ...paperTowelHolderPTH.tc_1995.x ];
paperTowelHolderPTH.tc_1995_2.y = [ ...hexagonHolderHH.tc_1995_2.y ];
fillArrayHoles([ { distance: 0.038, repeat: 3 } ], 3, paperTowelHolderPTH.tc_1947.x, 0.065);
fillArrayHoles([ { distance: 0.038, repeat: 26 } ], 26, paperTowelHolderPTH.tc_1947.y, 0.894);

paperTowelHolderPTH.amh_tc.x = [ ...hexagonHolderHH.amh_tc.x ].splice(1, 13);
paperTowelHolderPTH.amh_tc.y = [ ...hexagonHolderHH.amh_tc.y ].splice(0, 32);
paperTowelHolderPTH.amh_tc_el.x = [ ...paperTowelHolderPTH.amh_tc.x ];
paperTowelHolderPTH.amh_tc_el.y = [ ...paperTowelHolderPTH.amh_tc.y ];

paperTowelHolderPTH.hard_1000.y = [ ...hexagonHolderHH.hard_1000.y ].splice(1, 19);
paperTowelHolderPTH.hard_1000.x = [ ...hexagonHolderHH.hard_1000.x ].splice(1, 18);
paperTowelHolderPTH.hard_2000.y = [ ...hexagonHolderHH.hard_2000.y ].splice(1, 46);
paperTowelHolderPTH.hard_2000.x = [ ...hexagonHolderHH.hard_2000.x ].splice(1, 18);

//держатель пластикового ящика
plasticBoxHolder200SPBH.tc_1995.x = [ ...hexagonHolderHH.tc_1995.x ];
plasticBoxHolder200SPBH.tc_1995.y = [ ...hexagonHolderHH.tc_1995.y ];
plasticBoxHolder200SPBH.tc_1095.x = [ ...hexagonHolderHH.tc_1095.x ];
plasticBoxHolder200SPBH.tc_1095.y = [ ...hexagonHolderHH.tc_1095.y ];

plasticBoxHolder200SPBH.tc_1995_2.y = [ ...hexagonHolderHH.tc_1995_2.y ];
plasticBoxHolder200SPBH.tc_1995_2.x = [ ...hexagonHolderHH.tc_1995_2.x ];
plasticBoxHolder200SPBH.tc_1947.x = [ ...hexagonHolderHH.tc_1947.x ];
plasticBoxHolder200SPBH.tc_1947.y = [ ...hexagonHolderHH.tc_1947.y ];

plasticBoxHolder200SPBH.amh_tc.y = [ ...hexagonHolderHH.amh_tc.y ].splice(0, 32);
plasticBoxHolder200SPBH.amh_tc.x = [ ...hexagonHolderHH.amh_tc.x ];
plasticBoxHolder200SPBH.amh_tc_el.y = [ ...hexagonHolderHH.amh_tc_el.y ].splice(0, 32);
plasticBoxHolder200SPBH.amh_tc_el.x = [ ...hexagonHolderHH.amh_tc_el.x ];
plasticBoxHolder200SPBH.hard_1000.y = [ ...hexagonHolderHH.hard_1000.y ];
plasticBoxHolder200SPBH.hard_1000.x = [ ...hexagonHolderHH.hard_1000.x ];
plasticBoxHolder200SPBH.hard_2000.y = [ ...hexagonHolderHH.hard_2000.y ];
plasticBoxHolder200SPBH.hard_2000.x = [ ...hexagonHolderHH.hard_2000.x ];

//Полка большая LSh
shelfLargeLSH.amh_tc.y = [ ...hexagonHolderHH.amh_tc.y ];
shelfLargeLSH.amh_tc.x = [ ...hexagonHolderHH.amh_tc.x ].splice(0, 9);
shelfLargeLSH.amh_tc_el.y = [ ...hexagonHolderHH.amh_tc_el.y ];
shelfLargeLSH.amh_tc_el.x = [ ...shelfLargeLSH.amh_tc.x ];
shelfLargeLSH.hard_2000.y = [ ...hexagonHolderHH.hard_2000.y ].splice(1, 46);
shelfLargeLSH.hard_2000.x = [ ...hexagonHolderHH.hard_2000.x ].splice(0, 14);
shelfLargeLSH.hard_1000.y = [ ...hexagonHolderHH.hard_1000.y ].splice(1, 19);
shelfLargeLSH.hard_1000.x = [ ...shelfLargeLSH.hard_2000.x ];

//Лоток держатель А4
fillArrayHoles([
    { distance: 0.038, repeat: 2 }, { distance: 0.366, repeat: 1 },
    { distance: 0.038, repeat: 2 },
], 6, trayHolderA4.tc_1995.x, -0.392);
trayHolderA4.tc_1995.y = [ ...hexagonHolderHH.tc_1995.y ];
fillArrayHoles([ { distance: 0.038, repeat: 3 } ], 3, trayHolderA4.tc_1947.x, 0.065);
fillArrayHoles([ { distance: 0.038, repeat: 25 } ], 26, trayHolderA4.tc_1947.y, 0.894);

trayHolderA4.tc_1095.x = [ ...trayHolderA4.tc_1995.x ];
trayHolderA4.tc_1095.y = [ ...hexagonHolderHH.tc_1095.y ].splice(4, 20);
trayHolderA4.tc_1995_2.x = [ ...trayHolderA4.tc_1995.x ];
trayHolderA4.tc_1995_2.y = [ ...plasticBoxHolder200SPBH.tc_1995_2.y ];

trayHolderA4.amh_tc.y = [ ...hexagonHolderHH.amh_tc.y ].splice(0, 32);
fillArrayHoles([ { distance: 0.038, repeat: 15 } ], 15, trayHolderA4.amh_tc.x, -0.392);
trayHolderA4.amh_tc_el.y = [ ...trayHolderA4.amh_tc.y ];
trayHolderA4.amh_tc_el.x = [ ...trayHolderA4.amh_tc.x ];

trayHolderA4.hard_2000.y = [ ...hexagonHolderHH.hard_2000.y ].splice(4, 43);
fillArrayHoles([
    { distance: 0.038, repeat: 20 },
], 20, trayHolderA4.hard_2000.x, -0.494);
trayHolderA4.hard_1000.y = [ ...trayHolderA4.hard_2000.y ].splice(0, 16);
trayHolderA4.hard_1000.x = [ ...trayHolderA4.hard_2000.x ];

//Держатель УШМ
fillArrayHoles([
    { distance: 0.038, repeat: 3 }, { distance: 0.29, repeat: 1 },
    { distance: 0.038, repeat: 3 },
], 8, ushmHolder.tc_1995.x, -0.354);
ushmHolder.tc_1995.y = [ ...paperTowelHolderPTH.tc_1995.y ];

fillArrayHoles([ { distance: 0.038, repeat: 1 } ], 1, ushmHolder.tc_1947.x, 0.141);
ushmHolder.tc_1947.y = [ ...paperTowelHolderPTH.tc_1947.y ];

ushmHolder.tc_1095.x = [ ...ushmHolder.tc_1995.x ];
ushmHolder.tc_1095.y = [ ...hexagonHolderHH.tc_1095.y ];
ushmHolder.tc_1995_2.x = [ ...ushmHolder.tc_1995.x ];
ushmHolder.tc_1995_2.y = [ ...hexagonHolderHH.tc_1995_2.y ];


ushmHolder.amh_tc.y = [ ...hexagonHolderHH.amh_tc.y ].splice(0, 32);
fillArrayHoles([ { distance: 0.038, repeat: 13 } ], 13, ushmHolder.amh_tc.x, -0.323);
ushmHolder.amh_tc_el.y = [ ...ushmHolder.amh_tc.y ];
ushmHolder.amh_tc_el.x = [ ...ushmHolder.amh_tc.x ];
ushmHolder.hard_2000.y = [ ...hexagonHolderHH.hard_2000.y ].splice(1, 45);
fillArrayHoles([ { distance: 0.038, repeat: 17 } ], 17, ushmHolder.hard_2000.x, -0.399);
ushmHolder.hard_1000.y = [ ...hexagonHolderHH.hard_1000.y ].splice(1, 19);
ushmHolder.hard_1000.x = [ ...ushmHolder.hard_2000.x ];


//крючок центр +0.019
fillArrayHoles([
    { distance: 0.038, repeat: 9 }, { distance: 0.1, repeat: 1 },
    { distance: 0.038, repeat: 9 },
], 20, hookHk280.tc_1995.x, -0.39);

fillArrayHoles([
    { distance: 0.038, repeat: 10 }, { distance: 0.124, repeat: 1 },
    { distance: 0.038, repeat: 10 }, { distance: 0.124, repeat: 1 },
    { distance: 0.038, repeat: 10 },
], 33, hookHk280.tc_1995.y, 0.387);

fillArrayHoles([ { distance: 0.038, repeat: 10 } ], 10, hookHk280.tc_1947.x, 0.065);
fillArrayHoles([ { distance: 0.038, repeat: 25 } ], 25, hookHk280.tc_1947.y, 0.894);


fillArrayHoles([
    { distance: 0.038, repeat: 10 }, { distance: 0.019, repeat: 3 },
    { distance: 0.038, repeat: 9 },
], 23, hookHk280.tc_1095.y, 0.092);
fillArrayHoles([
    { distance: 0.038, repeat: 10 }, { distance: 0.124, repeat: 1 },
    { distance: 0.038, repeat: 10 },
], 22, hookHk280.tc_1995_2.y, 0.387, 0.501, 0.837);
hookHk280.tc_1095.x = [ ...hookHk280.tc_1995.x ];
hookHk280.tc_1995_2.x = [ ...hookHk280.tc_1995.x ];

fillArrayHoles([ { distance: 0.038, repeat: 20 } ], 20, hookHk280.amh_tc.x, -0.361);
fillArrayHoles([ { distance: 0.038, repeat: 32 } ], 32, hookHk280.amh_tc.y, 0.616);
hookHk280.amh_tc_el.y = [ ...hookHk280.amh_tc.y ];
hookHk280.amh_tc_el.x = [ ...hookHk280.amh_tc.x ];


hookHk280.hard_2000.y = [ ...hexagonHolderHH.hard_2000.y ].splice(0, 46);
fillArrayHoles([ { distance: 0.038, repeat: 25 } ], 25, hookHk280.hard_2000.x, -0.456);
hookHk280.hard_1000.y = [ ...hookHk280.hard_2000.y ].splice(0, 19);
hookHk280.hard_1000.x = [ ...hookHk280.hard_2000.x ];


//пластиковый ящик - pivot наверху сзади в центре(для удобства крепления на держатель)
plasticBox400x230x150.tc_1995.x = [ ...hexagonHolderHH.tc_1995.x ];
fillArrayHoles([
    { distance: 0.038, repeat: 1 }, { distance: 0.086, repeat: 1 },
    { distance: 0.038, repeat: 11 }, { distance: 0.086, repeat: 1 },
    { distance: 0.038, repeat: 11 }, { distance: 0.086, repeat: 1 },
    { distance: 0.038, repeat: 11 },
], 38, plasticBox400x230x150.tc_1995.y, 0.333);


plasticBox400x230x150.tc_1095.x = [ ...hexagonHolderHH.tc_1095.x ];
fillArrayHoles([
    { distance: 0.038, repeat: 10 }, { distance: 0.019, repeat: 3 },
    { distance: 0.038, repeat: 10 },
], 22, plasticBox400x230x150.tc_1095.y, 0.238);


plasticBox400x230x150.tc_1995_2.x = [ ...hexagonHolderHH.tc_1995_2.x ];
fillArrayHoles([
    { distance: 0.038, repeat: 1 }, { distance: 0.086, repeat: 1 },
    { distance: 0.038, repeat: 15 },
    { distance: 0.038, repeat: 4 },{ distance: 0.086, repeat: 1 },
    { distance: 0.038, repeat: 10 },
], 33, plasticBox400x230x150.tc_1995_2.y, 0.333, 0.193, 1.027);



plasticBox400x230x150.tc_1947.x = [ ...hexagonHolderHH.tc_1947.x ];
fillArrayHoles([ { distance: 0.038, repeat: 41 } ], 41, plasticBox400x230x150.tc_1947.y, 0.356);


plasticBox400x230x150.amh_tc.x = [ ...hexagonHolderHH.amh_tc.x ].splice(1, 17);
fillArrayHoles([ { distance: 0.038, repeat: 38 } ], 38, plasticBox400x230x150.amh_tc.y, 0.42);
plasticBox400x230x150.amh_tc_el.x = [ ...hexagonHolderHH.amh_tc_el.x ].splice(1, 17);
plasticBox400x230x150.amh_tc_el.y = [ ...plasticBox400x230x150.amh_tc.y ];

plasticBox400x230x150.hard_2000.x = [ ...hexagonHolderHH.hard_2000.x ].splice(1, 22);
fillArrayHoles([ { distance: 0.038, repeat: 44 } ], 44, plasticBox400x230x150.hard_2000.y, 0.289);
plasticBox400x230x150.hard_1000.x = [ ...hexagonHolderHH.hard_1000.x ].splice(1, 22);
plasticBox400x230x150.hard_1000.y = [ ...plasticBox400x230x150.hard_2000.y ].splice(0, 18);

